import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PaginationOutputModel } from './pagination-models/pagination-output.model';

@Component({
    selector: 'pagination',
    templateUrl: 'pagination.component.html'
})

export class PaginationComponent implements OnInit {

    @Input() countPerPage: number;
    @Input() currentPage: number;
    @Input() pageCount: number;
    @Output() changePage = new EventEmitter();

    private resultsPerPage: number;
    private maxPage: number;
    private minPage: number;
    private displayPages: number[];

    public displayMe = false;
    private displayPageNum = 7;

    ngOnInit(): void {
        this.setup();
    }

    setup(): void {
        this.displayMe = false;
        this.resultsPerPage = this.countPerPage;
        this.maxPage = this.pageCount;
        this.minPage = 1;
        this.buildDisplayPages();
    }

    private buildDisplayPages(): void {
        let offset = this.displayPageNum - 1;
        let halfOffset = offset / 2;
        let startNum = this.minPage;
        let endNum = this.minPage;

        if (this.pageCount <= this.displayPageNum) {
            startNum = this.minPage;
            endNum = this.maxPage;
        } else {
            if (this.currentPage == this.minPage) {
                endNum = this.currentPage + offset;
                if (endNum > this.maxPage) {
                    endNum = this.maxPage;
                }
            }

            if (this.currentPage > this.minPage) {
                if (this.currentPage - halfOffset > this.minPage) {
                    startNum = this.currentPage - halfOffset;
                }

                if (this.currentPage + offset <= this.maxPage) {
                    endNum = this.currentPage + halfOffset;
                } else if (this.currentPage + halfOffset <= this.maxPage) {
                    endNum = this.currentPage + halfOffset;
                } else if (this.currentPage + halfOffset > this.maxPage) {
                    endNum = this.maxPage;
                }
            }
            if (this.currentPage == this.maxPage) {
                startNum = this.currentPage - offset;
                if (startNum < this.minPage) {
                    startNum = this.minPage;
                }
            }
        }

        this.displayPages = [];
        for (let i = startNum; i <= endNum; i++) {
            this.displayPages.push(i);
        }
        this.displayMe = true;
    }

    public change(page: number) {
        if (page != this.currentPage && page >= this.minPage && page <= this.maxPage) {
            //this.currentPage = page;
            //this.buildDisplayPages();
            let skip = this.countPerPage * (page - 1);
            let pageOutput: PaginationOutputModel = {
                pageNum: page,
                skipNum: skip,
                takeNum: this.countPerPage
            };
            this.changePage.emit(pageOutput);
        }
    }

}


// WEBPACK FOOTER //
// ./angularApp/app/pagination/pagination.component.ts